// Development / Test ortamı — dev.pusulatatil.com → devapi (Gordios WS)
export const environment = {
  production: false,
  apiUrl: 'https://devapi.pusulatatil.com/api',
  baseUrl: 'https://devapi.pusulatatil.com'
};
